// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__Kd2KD","DisableMobileLogo":"Logo_DisableMobileLogo__R545B"};